import { z } from 'zod';
import { isoTimestampSchema, syncBookkeepingSchema, uuidSchema } from './base.js';

export const projectColorSchema = z
  .string()
  .regex(/^#[0-9a-fA-F]{6}$/)
  .nullable();

export const projectSchema = syncBookkeepingSchema.extend({
  id: uuidSchema,
  name: z.string().min(1).max(200),
  color: projectColorSchema,
  icon: z.string().max(40).nullable(),
  description: z.string().max(20_000).nullable(),
  sort_key: z.string().min(1),
  archived_at: isoTimestampSchema.nullable(),
});

export type Project = z.infer<typeof projectSchema>;

export const projectCreateSchema = projectSchema
  .pick({ id: true, name: true, color: true, icon: true, description: true, sort_key: true })
  .partial({ color: true, icon: true, description: true });

export const projectPatchSchema = projectSchema
  .pick({
    name: true,
    color: true,
    icon: true,
    description: true,
    sort_key: true,
    archived_at: true,
  })
  .partial();

export type ProjectCreate = z.infer<typeof projectCreateSchema>;
export type ProjectPatch = z.infer<typeof projectPatchSchema>;
